module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('form', {
    staticClass: "form-horizontal well"
  }, [_c('fieldset', [(!this.$route.params.id) ? _c('legend', [_vm._v("New Rubric")]) : _vm._e(), _vm._v(" "), (this.$route.params.id) ? _c('legend', [_vm._v("Edit Rubric")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.editing) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Changing this name will create a duplication and "), _c('i', [_vm._v("not")]), _vm._v(" change the element's name.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Label")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.label),
      expression: "form.label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.label)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.label = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.number),
      expression: "form.number",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "99",
      "placeholder": "1 - 99"
    },
    domProps: {
      "value": (_vm.form.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.number = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Transmitter Groups")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.formData.transmittergroups,
      "multiple": true,
      "close-on-select": false,
      "hide-selected": true,
      "clear-on-select": true,
      "placeholder": "Type to search",
      "label": "name",
      "track-by": "name"
    },
    model: {
      value: (_vm.form.transmittergroups),
      callback: function($$v) {
        _vm.form.transmittergroups = $$v
      },
      expression: "form.transmittergroups"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Owner")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.formData.users,
      "multiple": true,
      "close-on-select": false,
      "hide-selected": true,
      "clear-on-select": true,
      "placeholder": "Type to search",
      "label": "name",
      "track-by": "name"
    },
    model: {
      value: (_vm.form.owners),
      callback: function($$v) {
        _vm.form.owners = $$v
      },
      expression: "form.owners"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-10 col-lg-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/rubrics"
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Abort")])])], 1)])])])]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Rubrics")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3"
  }, [_c('h2', [_vm._v("Information")]), _vm._v(" "), _c('p', [_vm._v("Rubrics are a Skyper based invention allowing to send news sorted into chategories (the rubrics). Assign the number with care and contact "), _c('code', [_vm._v("rwth-afu [at] online.de")]), _vm._v(" in case of doubt. Be aware that the number of rubrics is limited netwide to 99.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68d371da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rubric/New.vue
// module id = 624
// module chunks = 1